import { render, staticRenderFns } from "./filtered_search_suggestion.vue?vue&type=template&id=9deb025a"
import script from "./filtered_search_suggestion.vue?vue&type=script&lang=js"
export * from "./filtered_search_suggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports